import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AgenciesService } from '@modules/flights/services/agencies.service';
import {
  EmissionsNoticeVariant,
  consumeEmissionsNoticePending,
  getEmissionsNoticeVariant,
  isGrupo8ChildAgency,
} from '@utils/emissionsNotice';
import { ModalEmissionsNoticeComponent } from './modal-emissions-notice.component';

@Injectable({
  providedIn: 'root',
})
export class EmissionsNoticeService {
  constructor(
    private dialog: MatDialog,
    private agenciesService: AgenciesService,
  ) {}

  /**
   * Abre el aviso de Emisiones vigente si el usuario recién ingresó
   * (CAT-5153, CAT-5181). Las agencias hijas se excluyen cuando Grupo 8 es
   * uno de sus consolidadores.
   */
  showIfPending(): void {
    if (!consumeEmissionsNoticePending()) return;
    const variant = getEmissionsNoticeVariant();
    if (!variant) return;

    const agency = JSON.parse(localStorage.getItem('user') || 'null')?.agency;
    if (!agency?.isChild || !agency.agencyId) {
      this.open(variant);
      return;
    }

    this.agenciesService.getConsolidators(agency.agencyId).subscribe({
      next: (response) => {
        if (!isGrupo8ChildAgency(response.consolidators ?? [])) this.open(variant);
      },
      error: () => this.open(variant),
    });
  }

  private open(variant: EmissionsNoticeVariant): void {
    this.dialog.open(ModalEmissionsNoticeComponent, {
      data: { variant },
      width: '560px',
      maxWidth: 'calc(100vw - 2rem)',
      panelClass: 'modal-emissions-notice-panel',
      autoFocus: false,
    });
  }
}
